import styled from 'styled-components';

export const PageContent = styled.div`
  padding: 0 40px 40px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 0 10px 10px;
  }

  ${(props) => props.flex100 && `
    flex: 1;
    min-height: 0;
  `}
`;
